// import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
// import { Trash, CircleSlash2, AlertTriangle } from "lucide-react";
import {
    Modal as ModalNewOrder,
    Box,
    Typography,
    TextField,
    Autocomplete,
    Button,
    IconButton,
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    Switch,
    ListItemText, ListItem
} from '@mui/material';
import React, { useState, useEffect, } from "react";
import Modal from '@mui/material/Modal';
// import Box from '@mui/material/Box';
// import { Button } from '../components/ui/button';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

import { Edit, Trash } from 'lucide-react';

import { Formik, Field, Form, FormikConsumer, useFormik } from 'formik';
import * as Yup from 'yup';

import { format, parseISO } from "date-fns"; // Importamos date-fns
import { es } from "date-fns/locale"; // Español
import inboundService from "../../services/InboundService";
import TransportistasService from '../../services/TransportistasService';

const ModalContainer = ({ openModalContainer, onClose, updateContenedoresParent,
    isEditContenedor, setisEditContenedor,
    contenedorSelected, updateContenedoresWhenUpdate1Contenedor }) => {


    const validatorContenedorNoRepeat = (value) => {


        if (!value) return false; // Maneja valores vacíos

        const find = contenedores.find(contenedor => contenedor.contenedor == value);

        if (find && isEditContenedor === true && contenedorSelected.contenedor == find.contenedor) {
            return true

        } else if (find) {
            return false;
        } else {
            return true;
        }
    };

    const validatorNoSpaces = (value) => !/\s/.test(value);

    const formikContenedor = useFormik({
        initialValues: {
            cuenta: null,
            pedimento: "",
            folio: "",
            contenedor: "",
            cantidad: "",
            origen: "",
            bodega: "",
            ubicacion: "",
            naviera: "",
            puerta_vacio: "",
            puerta_vacio_direccion: "",
            hora_de_cita: "",

        },
        validationSchema: Yup.object({
            cuenta: Yup.mixed().required("*requerido"),
            pedimento: Yup.string()
                .required("*requerido")
                .test("sin-espacios", "No puede contener espacios", validatorNoSpaces),
            folio: Yup.string()
                .required("*requerido")
                .test("sin-espacios", "No puede contener espacios", validatorNoSpaces),
            contenedor: Yup.string()
                .required("*requerido")
                .test("sin-espacios", "No puede contener espacios", validatorNoSpaces)
                .test(
                    "formato-contenedor", // Nombre de la validación
                    "Existe un contenedor con ese nombre", // Mensaje de error
                    validatorContenedorNoRepeat // Función que valida el valor
                ),
            cantidad: Yup.number().required("*requerido"),
            origen: Yup.mixed().required("*requerido"),
            bodega: Yup.mixed().required("requerido"),
            ubicacion: Yup.mixed().required("requerido"),
            puerta_vacio: Yup.mixed().required("*requerido"),
            naviera: Yup.mixed().required("*requerido"),
            hora_de_cita: Yup.string().required("*requerido"),
        }),
        onSubmit: (values, { resetForm }) => {
            handleFormSubmitContenedores(values, resetForm)
        },
    });



    const [contenedores, setContenedores] = useState([]);
    const [Cuentas, setCuentas] = useState([]);
    const [ubicaciones, setUbicaciones] = useState([]);
    const [origenes, setOrigenes] = useState([]);
    const [navieras, setNavieras] = useState([]);
    const [puertaVacios, setPuertaVacios] = useState([]);
    const [bodegas, setBodegas] = useState([]);
    const [puertaVacioDireccion, setPuertaVacioDireccion] = useState([]);

    const handleClosePrincipalModalContainer = () => {

        onClose();
        formikContenedor.resetForm();
    };



    const handleFormSubmitContenedores = async (values, resetForm) => {

        try {
            // console.log(values);

            // return
            if (isEditContenedor === true) {
                let data = {
                    "nombre_cuenta": values.cuenta.nombre_cuenta,
                    "pedimento": values.pedimento,
                    "folio": values.folio,
                    "contenedor": values.contenedor,
                    "cantidad": values.cantidad,
                    "id_origen": values.origen.id_inbound_origins,
                    "id_naviera": values.naviera.id_inbound_naviera,
                    "id_bodega": values.bodega.id,
                    "id_puerta_vacio": values.puerta_vacio.id_inbound_puerta_vacio,
                    "hora_de_cita": values.hora_de_cita
                }
                console.log(data, contenedorSelected.id_contenedor);

                // return 
                const responseUpdate = await inboundService.updateContenedor(contenedorSelected.id_contenedor, data)
                if (responseUpdate.data && responseUpdate.data.status == 200) {
                    toast.success("¡Operación exitosa!");
                    updateContenedoresWhenUpdate1Contenedor();
                    onClose();
                    formikContenedor.resetForm();
                    console.log("editado");

                } else {
                    console.error(`Error: El servidor respondió con estado ${response.status}`);
                    toast.error("Hubo un error");
                }


                return;
            }
            const response = await inboundService.postCreateContenedores({
                "nombre_cuenta": values.cuenta.nombre_cuenta,
                "pedimento": values.pedimento,
                "folio": values.folio,
                "contenedor": values.contenedor,
                "cantidad": values.cantidad,
                "id_origen": values.origen.id_inbound_origins,
                "id_naviera": values.naviera.id_inbound_naviera,
                "id_bodega": values.bodega.id,
                "id_puerta_vacio": values.puerta_vacio.id_inbound_puerta_vacio,
                "hora_de_cita": values.hora_de_cita
            })
            // fetch('${process.env.REACT_APP_API_URL}/api/v1/inbound/contenedores/create/', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify({
            //         "nombre_cuenta": values.cuenta.nombre_cuenta,
            //         "pedimento": values.pedimento,
            //         "folio": values.folio,
            //         "contenedor": values.contenedor,
            //         "cantidad": values.cantidad,
            //         "id_origen": values.origen.id_inbound_origins,
            //         "id_naviera": values.naviera.id_inbound_naviera,
            //         "id_bodega": values.bodega.id,
            //         "id_puerta_vacio": values.puerta_vacio.id_inbound_puerta_vacio,
            //         "hora_de_cita": values.hora_de_cita
            //     })
            // });

            if (response.status === 200) { // Verifica si el servidor devuelve 200
                const data = await response.data;
                toast.success("¡Operación exitosa!");
                onClose();

                // updateContenedoresParent();
                resetForm();


            } else {
                console.error(`Error: El servidor respondió con estado ${response.status}`);
                toast.error("Hubo un error");
            }

        } catch (error) {
            console.error('Error:', error);
            toast.error("Hubo un error");
        }



    };


    const handleBodegaChange = (value) => {
        // Actualizamos el campo 'cliente' en Formik
        formikContenedor.setFieldValue("bodega", value);


        // Si hay un valor seleccionado, filtramos las ubicaciones relacionadas
        if (value !== null) {
            setUbicaciones([value])
            formikContenedor.setFieldValue("ubicacion", value); // Reinicia el campo de ubicación
        } else {
            // Si no hay valor seleccionado, reiniciamos las ubicaciones
            setUbicaciones([]);
            formikContenedor.setFieldValue("ubicacion", null); // Reinicia el campo de ubicación
        }
    };

    const handlePuertaVacioChange = (value) => {

        formikContenedor.setFieldValue("puerta_vacio", value);



        if (value !== null) {
            setPuertaVacioDireccion([value])
            formikContenedor.setFieldValue("puerta_vacio_direccion", value);
        } else {

            setPuertaVacioDireccion([]);
            formikContenedor.setFieldValue("puerta_vacio_direccion", null);
        }
    };

    const chargeContenedores = async () => {

        const responseContenedores = await inboundService.getContenedores();
        if (responseContenedores.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data = await responseContenedores.data;


        setContenedores(data);
    }

    const onInit = async () => {
        await chargeContenedores();

        const response = await TransportistasService.getCuentas();
        if (response.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data = await response.data;
        setCuentas(data)

        const response2 = await TransportistasService.getBodegas();
        if (response2.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data2 = await response2.data;

        setBodegas(data2)

        const response5 = await inboundService.getOrigins();
        if (response5.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data5 = await response5.data;

        setOrigenes(data5)

        const response6 = await inboundService.getNavieras();
        if (response6.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data6 = await response6.data;

        setNavieras(data6)

        const response7 = await inboundService.getPuertaVacios();
        if (response7.status != 200) {
            throw new Error('Error al obtener los datos');
        }
        const data7 = await response7.data;

        setPuertaVacios(data7)

        if (isEditContenedor === true) {
            console.log("valor recibido:", contenedorSelected);

            const getCuenta = data.find(cuenta => cuenta.nombre_cuenta === contenedorSelected.nombre_cuenta);
            formikContenedor.setFieldValue("cuenta", getCuenta)

            formikContenedor.setFieldValue("pedimento", contenedorSelected.pedimento)
            formikContenedor.setFieldValue("folio", contenedorSelected.folio)
            formikContenedor.setFieldValue("contenedor", contenedorSelected.contenedor)
            formikContenedor.setFieldValue("cantidad", contenedorSelected.cantidad)

            const getOrigen = data5.find(origen => origen.id_inbound_origins === contenedorSelected.id_origen);
            formikContenedor.setFieldValue("origen", getOrigen)

            const getBodega = data2.find(bodega => bodega.id === contenedorSelected.id_bodega);
            handleBodegaChange(getBodega)

            const getNaviera = data6.find(naviera => naviera.id_inbound_naviera === contenedorSelected.id_naviera);
            formikContenedor.setFieldValue("naviera", getNaviera)

            const getPuertaVacio = data7.find(puerta => puerta.id_inbound_puerta_vacio === contenedorSelected.id_puerta_vacio);
            // formikContenedor.setFieldValue("puerta_vacio", getPuertaVacio)
            handlePuertaVacioChange(getPuertaVacio);

            formikContenedor.setFieldValue("hora_de_cita", contenedorSelected.hora_de_cita)

        }


    }

    useEffect(() => {
        if (openModalContainer) {
            onInit()


        }
    }, [openModalContainer]); // Se ejecuta cuando cambia isOpen


    return (
        <Modal open={openModalContainer} onClose={() => handleClosePrincipalModalContainer()}>

            {/* <Formik
                initialValues={initialValuesContenedor}
                validationSchema={validationSchemaContenedor}
                onSubmit={handleFormSubmitContenedores}
            >
                {({ setFieldValue, values, handleSubmit, errors, touched }) => (
                   
                )}
            </Formik> */}

            <Box className="bg-white p-6 rounded-lg shadow-lg w-1/3 mx-auto max-h-[80%]  overflow-y-auto mt-20">
                <h2 className="text-xl font-bold mb-4">{isEditContenedor === false ? "Crear contenedor" : "Editar Contenedor"}</h2>
                <form onSubmit={formikContenedor.handleSubmit}>

                    {/* Autocomplete para seleccionar cuenta */}
                    <div>
                        <Autocomplete
                            fullWidth
                            options={Cuentas}
                            getOptionLabel={(option) => option.nombre || ""}
                            onChange={(event, value) => {
                                formikContenedor.setFieldValue("cuenta", value);
                            }}
                            value={formikContenedor.values.cuenta || null} // Previene valores undefined
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Cuenta *"
                                    error={Boolean(formikContenedor.errors.cuenta && formikContenedor.touched.cuenta)} // Verifica si hay un error y si el campo fue tocado
                                    helperText={formikContenedor.touched.cuenta && formikContenedor.errors.cuenta} // Muestra el mensaje de error si el campo fue tocado
                                />
                            )}
                        />

                    </div>

                    <div className="mt-2 flex flex-row">

                        <div className="w-1/2 mr-2">
                            <TextField
                                label="Pedimento *"
                                {...formikContenedor.getFieldProps("pedimento")}
                                onChange={(event) => {
                                    formikContenedor.setFieldValue("pedimento", event.target.value.toUpperCase());
                                }}
                                error={Boolean(formikContenedor.touched.pedimento && formikContenedor.errors.pedimento)}
                                helperText={formikContenedor.touched.pedimento && formikContenedor.errors.pedimento ? formikContenedor.errors.pedimento : ""}
                            />

                        </div>
                        <div className="w-1/2">
                            <TextField

                                label="Folio *"
                                {...formikContenedor.getFieldProps("folio")}
                                onChange={(event) => {
                                    formikContenedor.setFieldValue("folio", event.target.value.toUpperCase());
                                }}
                                error={Boolean(formikContenedor.touched.folio && formikContenedor.errors.folio)}
                                helperText={formikContenedor.touched.folio && formikContenedor.errors.folio ? formikContenedor.errors.folio : ""}
                            />

                        </div>
                    </div>
                    <div className="mt-2 flex flex-row">

                        <div className="w-1/2 mr-2">
                            <TextField
                                label="Contenedor *"
                                {...formikContenedor.getFieldProps("contenedor")}
                                onChange={(event) => {
                                    formikContenedor.setFieldValue("contenedor", event.target.value.toUpperCase());
                                }}
                                error={Boolean(formikContenedor.touched.contenedor && formikContenedor.errors.contenedor)}
                                helperText={formikContenedor.touched.contenedor && formikContenedor.errors.contenedor ? formikContenedor.errors.contenedor : ""}
                            />
                        </div>
                        <div className="w-1/2 ">
                            <TextField
                                type="number"
                                name="cantidad"
                                label="Cantidad Pzas *"
                                {...formikContenedor.getFieldProps("cantidad")}
                                error={Boolean(formikContenedor.touched.cantidad && formikContenedor.errors.cantidad)}
                                helperText={formikContenedor.touched.cantidad && formikContenedor.errors.cantidad ? formikContenedor.errors.cantidad : ""}
                            />

                        </div>
                    </div>

                    <div className="mt-2 flex flex-row">

                        <div className="w-1/2 mr-2">

                            <Autocomplete
                                fullWidth
                                options={origenes}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(event, value) => {
                                    formikContenedor.setFieldValue("origen", value);
                                }}
                                value={formikContenedor.values.origen || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Origen *"
                                        error={Boolean(formikContenedor.errors.origen && formikContenedor.touched.origen)} // Verifica si hay un error y si el campo fue tocado
                                        helperText={formikContenedor.touched.origen && formikContenedor.errors.origen} // Muestra el mensaje de error si el campo fue tocado
                                    />
                                )}
                            />
                        </div>

                        <div className="w-1/2 ">

                            <Autocomplete
                                fullWidth
                                options={bodegas}
                                getOptionLabel={(option) => option.nombre || ""}
                                onChange={(event, value) => handleBodegaChange(value)}
                                value={formikContenedor.values.bodega || null} // Previene valores undefined
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Consignatario *"
                                        error={Boolean(formikContenedor.errors.bodega && formikContenedor.touched.bodega)} // Verifica si hay un error y si el campo fue tocado
                                        helperText={formikContenedor.touched.bodega && formikContenedor.errors.bodega} // Muestra el mensaje de error si el campo fue tocado
                                    />
                                )}
                            />
                        </div>


                    </div>

                    <div className="mt-2 flex flex-row">

                        <div className="w-1/2 mr-2">

                            <Autocomplete
                                fullWidth
                                options={navieras}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(event, value) => {
                                    formikContenedor.setFieldValue("naviera", value);
                                }}
                                value={formikContenedor.values.naviera || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Naviera *"
                                        error={Boolean(formikContenedor.errors.naviera && formikContenedor.touched.naviera)} // Verifica si hay un error y si el campo fue tocado
                                        helperText={formikContenedor.touched.naviera && formikContenedor.errors.naviera} // Muestra el mensaje de error si el campo fue tocado
                                    />
                                )}
                            />
                        </div>

                        <div className="w-1/2 ">


                            <Autocomplete
                                fullWidth
                                options={ubicaciones}
                                getOptionLabel={(option) => option.direccion || ""}

                                value={formikContenedor.values.ubicacion || null} // Previene valores undefined
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Ubicacion *"

                                    />
                                )}
                            />
                        </div>





                    </div>

                    <div className="flex flex-row  mt-3">

                        <div className="w-1/2 mr-2">

                            <Autocomplete
                                fullWidth
                                options={puertaVacios}
                                getOptionLabel={(option) => option.nombre}
                                onChange={(event, value) => handlePuertaVacioChange(value)}
                                value={formikContenedor.values.puerta_vacio || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Puerta Vacio *"
                                        error={Boolean(formikContenedor.errors.puerta_vacio && formikContenedor.touched.puerta_vacio)} // Verifica si hay un error y si el campo fue tocado
                                        helperText={formikContenedor.touched.puerta_vacio && formikContenedor.errors.puerta_vacio} // Muestra el mensaje de error si el campo fue tocado
                                    />
                                )}
                            />
                        </div>


                        <div className="w-1/2 ">


                            <TextField
                                label="Hora de cita(entrega)"
                                type="datetime-local"
                                name="hora_de_cita"
                                InputLabelProps={{
                                    shrink: true, // Asegura que el label se mantenga arriba
                                }}
                                fullWidth
                                variant="outlined"
                                onChange={(event, value) => {
                                    formikContenedor.setFieldValue("hora_de_cita", event.target.value);
                                }}
                                value={formikContenedor.values.hora_de_cita}
                                className={` ${formikContenedor.touched.hora_de_cita && formikContenedor.errors.hora_de_cita ? 'border-red-500' : ''}`}
                            />
                            {formikContenedor.touched.hora_de_cita && formikContenedor.errors.hora_de_cita && (
                                <div className="text-red-500 text-sm">{formikContenedor.errors.hora_de_cita}</div>
                            )}

                        </div>



                    </div>

                    <div className="flex flex-row  mt-3">

                        <div className="w-1/2 mr-2">


                            <Autocomplete
                                fullWidth
                                options={puertaVacioDireccion}
                                getOptionLabel={(option) => option.direccion || ""}

                                value={formikContenedor.values.puerta_vacio_direccion || null} // Previene valores undefined
                                disableClearable
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Dir. Puerta vacio *"
                                    />
                                )}
                            />
                        </div>

                        <div className="w-1/2 ">
                            {/* Espacio vacio */}

                        </div>

                    </div>




                    <div className="flex felx-row justify-between items-end">
                        {/* Botón para cerrar modal */}
                        <Button type="button" onClick={() => handleClosePrincipalModalContainer()}>
                            Cerrar
                        </Button>
                        {/* Botón corregido para asegurar envío */}
                        <button type="submit"
                            className="bg-blue-500 text-white px-4 py-2 rounded mt-4"
                            disabled={formikContenedor.isSubmitting} // Deshabilitar el botón si está enviando
                        >
                            {isEditContenedor === false ? "Crear" : "Editar"}
                        </button>

                    </div>
                </form>
            </Box>




        </Modal>
    );
};

export default ModalContainer;
